import { useSurePlans } from 'flows/insurance/utils';
import { useEffect, useState } from 'react';
import { useUserData } from './use-profile';

type PropertyAddress = {
  city: string;
  postal: string;
  unit: string;
  region: string;
  street_address: string;
  country_code: 'US';
};

/**
 * hook to retrieve sure plan information
 * @returns {data, loading, error}
 */
export const useInsuranceProviderData = () => {
  const [propertyAddres, setPropertyAddress] = useState<PropertyAddress | null>(
    null
  );
  const result = useSurePlans(propertyAddres);
  const { user, loading: userLoading } = useUserData();

  useEffect(() => {
    const toAddress = user?.currentMove?.toAddress;
    if (toAddress) {
      setPropertyAddress({
        city: toAddress.city ?? '',
        postal: toAddress.postalCode ?? '',
        unit: toAddress.unit || '',
        region: toAddress.state ?? '',
        street_address: toAddress.street ?? '',
        country_code: 'US',
      });
    }
  }, [user, userLoading]);
  return result;
};
